export const Rebate = {
    NotSelect: '— Not selected —',
    KeepUnchanged: 'Keep unchanged',
    KeepUnchangedStrategyTip:
        'The account permission of this sub-type stays unchanged; only the rebate strategy is configured here. Leave it blank to keep its existing rebate strategy.',
    AccountPermission: 'Account Permission',
    UpdateLink: 'Update Link',
    AddLink: 'Add Link',
    AccountPermissionDesc: 'Configure the MT4 / MT5 account level combination for the current link.',
    ClientGroupConfig: 'Client Group Config',
    ClientGroup: 'Client Group',
    SelectLink: 'Select Link',
    SelectLinkDesc: 'The rebate strategy is auto-generated from the de-duplicated sub-types of all saved links.',
    NoLink: 'No link yet. Please add one in "Account Permission" above.',
    LinkNew: 'New Link',
    LinkExisting: 'Existing Link',
    DefaultLink: 'Default Link',
    SubType: 'Sub-type',
    FxValue: 'FX Value',
    MetalValue: 'Metal Value',
    StrategyEmpty: 'Please add or keep related sub-types in "Select Link" above',
    RebateStrategyTitle: 'Rebate Strategy',
    TopIbStrategyReadonlyTip: 'The rebate strategy cannot be changed when a client is upgraded to Top IB',
    IsTopIbStrategyReadonlyTip: 'The rebate strategy cannot be changed when the client is a Top IB',
    UnitNote: '* All value units are subject to the actual agreement',
    HintSelectAtLeastOne: 'Please select at least one account permission',
    HintDuplicateLink: 'A link with the same configuration already exists',
    HintLinkAdded: 'Link added',
    HintLinkUpdated: 'Link updated',
    TopTier: 'Top Tier',
    UpgradeTopIbTitle: 'Client Upgrade to Top IB',
    UpgradeToTopAgent: 'Upgrade to top-level agent?',
    SelectTopGroup: 'Select top group',
    NoSuperiorAgentTip: 'No superior agent. Please bind one first and try again.',
    UpgradeSubIbTitle: 'Client Upgrade to Sub IB',
    UpdateRebateConfigTitle: 'IB Rebate Config Update',
    IbConfigAuditApprove: 'Approved: {auditComment}',
    IbConfigAuditReject: 'Rejection reason: {auditComment}',
    KycNotPassedTip: 'The client KYC is not fully approved yet',
    HasPendingTip: 'This account already has a pending work order, please wait until it is processed',
    CheckPendingTip: 'Checking work-order status...',
    AlreadyIbTip: "This account's passport is already linked to an IB product; the IB cannot be enabled again",
    RebateExceedTitle: 'Rebate Validation Failed',
    RebateExceedDesc: "The following rebate values exceed the superior agent's limit. Please adjust and resubmit:",
    PreviewStrategyTitle: 'Rebate Strategy Preview',
    Symbol: 'Symbol Group',
    BasicMoney: 'Basic Rebate',
    AddCommMoney: 'Commission Rebate',
    AddPointPoint: 'Point Rebate',
    ColMoney: 'Amount',
    ColPercentage: 'Percentage',
    ColPoint: 'Point',
    HintFillAllValues: 'Please fill in all rebate values',
    HintDefaultLinkRequired: 'Please select a default link',
    HintMixedLinkNeedsUpdate:
        'The following links mix sub-types of different group categories. Select each link and click "Update Link" before submitting: ',
    RebateSettingConflictTip:
        'The rebate amount is less than the sub-level or greater than the upper-level. Details below:',
    ColAction: 'Action',
    DeleteStrategyConfirm: "Delete this sub-type's rebate strategy?",
    DeleteLockedTip: 'This group has bound clients and cannot be deleted',
    DeleteLockedByMoveTip: 'Clients have been moved into this link and it cannot be deleted',
    FilterByLink: 'Group Name',
    FilterPlaceholder: 'Search group name...',
    FilterHint:
        'Selected {selected} / {total} links: strategy below shows only selected sub-types (deduplicated), all link data will be submitted',
    ExistingLink: 'Existing',
    SelectAll: 'Select All',
    // ── Select link - Setting (account list / permission / client move, meegle 14436933) ──
    LinkSetting: 'Setting',
    LinkSettingTitle: 'Setting - {name}',
    LinkSettingNewTip: 'This link has not been created yet, no account data',
    AccountListTab: 'Account List',
    AccountPermissionTab: 'Account Permission',
    PermissionHistoryTip: 'Results below are existing data and do not include changes in this ticket',
    AccountSearchPlaceholder: 'Search by account ID / name',
    JoinTime: 'Join Time',
    AllServers: 'All Servers',
    AllBasicTypes: 'All Basic Account Types',
    BatchMove: 'Batch Move',
    MoveTitle: 'Move Account',
    MoveTarget: 'Target Link',
    MoveCountTip: 'Moving {count} account(s): ',
    MoveSuccess: 'Moved successfully',
    MoveConfirmTitle: 'Move Confirmation',
    MoveConfirmDesc: 'Move the following {count} account(s) to a new client group?',
    MoveFromGroup: 'From group: ',
    MoveToGroup: 'To group: ',
    MoveConfirmWarning:
        "The account's account-opening permission and rebate strategy will follow the target client group. Please confirm.",
    MoveConfirmBack: 'Back to Edit',
    MoveConfirmOk: 'Confirm Move',
    MoveEffectTip: 'The move takes effect after the ticket is submitted and approved',
    MoveCancelledOnDelete: '{count} pending move(s) cancelled with the deleted link',
    HintNoMoveTarget: 'No other link available to move to',
    HintSelectMoveTarget: 'Please select a target link',
    HintMoveTargetEmpty:
        'The target link has no sub-type configured and cannot be created. Configure it or pick another target',
    HintMoveTargetDuplicateName: 'The target link name is duplicated, please rename it before submitting',
    // ── IB Rebate Strategy page (requirement 7) ──
    IbStrategyTitle: 'IB Rebate Strategy',
    Platform: 'MT Platform',
    BasicAccountType: 'Basic Account Type',
    SymbolGroup: 'Symbol Group',
    AllSymbolGroups: 'All Symbol Groups',
    AccountIdPlaceholder: 'Enter account ID to search',
    StrategyAccountPermission: 'Account Permission',
    BasicRebate: 'Basic Rebate',
    CommissionRebate: 'Commission Rebate',
    PointRebate: 'Point Rebate',
    // ── My IB list: aggregated trade volume ──
    TitleAggregatedTradeVolume: 'Aggregated Trading Volume',
    AggregatedTradeVolumeTip: 'Total trading volume of the list below',
    OneClickSync: 'Sync',
    OneClickClear: 'Clear All',
    ClearConfirm: 'Clear all rebate strategy values?',
    SyncNothing: 'Fill in rebate values for this rule first; other rules must have matching sub-types',
    SyncRounded: 'Some synced values exceeded the column precision and were rounded',
};
